// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DxmSzwV5YAltQr {
  max-width: 1250px;
  margin: 0 auto 24px auto;
  padding: 28px 20px 0px 32px;
  border-radius: 3px;
  background: linear-gradient(124.69deg, var(--ds-background-accent-purple-subtlest, #f3f0ff) 21.28%, var(--ds-background-accent-magenta-subtlest, #ffecf8) 80.94%);
}
.xw_SQ8RX3gB4pL {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"relatedTemplatesContainer": `DxmSzwV5YAltQr`,
	"tilesContainer": `xw_SQ8RX3gB4pL`
};
export default ___CSS_LOADER_EXPORT___;
